import script from "./HistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryView.vue?vue&type=script&setup=true&lang=js"

import "./HistoryView.vue?vue&type=style&index=0&id=ee3e458c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee3e458c"]])

export default __exports__